<template>
  <div>
    <pulse-loader v-if="loading" />
    <template v-else>
      <common-mso v-if="mso_login === true" :children="children" />
      <common-sso v-else />
    </template>
  </div>
</template>

<script>
import CommonSso from './CommonSso';
import CommonMso from './CommonMso';
import { CommonSecurity } from '@primeit/components-vue';
import PulseLoader from '../../../components/PulseLoader';

export default {
  components: {
    CommonSso,
    CommonMso,
    PulseLoader,
  },
  data: () => {
    return {
      loading: true,
      children: null,
      mso_login: undefined,
    };
  },
  computed: {
    setup() {
      return this.$store.getters['credential/SETUP'];
    },
    getUser() {
      return CommonSecurity.getUser();
    },
  },
  beforeMount() {
    if (document.location.pathname.startsWith('/emergency')) {
      window?.Tawk_API?.minimize();
      window?.Tawk_API?.hideWidget();
    }
  },
  async created() {
    const [user] = await Promise.all([
      this.getUser,
      this.$store.dispatch(
        'contract/FETCH_USE_EMERGENCY_MODULE',
        { companyId: this.setup.companyId }
      ),
    ]);

    if (!user && this.setup.landing && this.setup.landing.enabled) {
      const landingKnownPaths = ['/', '/professionals'];
      let params = {};
      if (!landingKnownPaths.includes(this.$route.path)) {
        params = {
          permalink: this.$route.path.replace('/', ''),
        };
      }
      return this.$router.replace({ name: 'landing', query: this.$route.query, replace: true, params });
    } else {
      return this.sendToCorrectCommon(user);
    }
  },
  methods: {
    async sendToCorrectCommon(user) {
      this.$root.$on('mso_failed', (_options) => {
        this.mso_login = false;
      });

      if (this.$route.query.mso !== 'on') {
        /// is not inside mso
        /// check multiple
        if (user && user.attributes.get('custom:roles') === 'P') {
          const usernameRaw = user.getAttribute('cognito:username');
          const username = usernameRaw.includes('@') ? usernameRaw.split('@')[1] : usernameRaw;

          await this.$store.dispatch('patient/FETCH_CHILDREN', username);
          this.children = await this.$store.getters['patient/GET_CHILDREN'];
          if (this.children && this.children.length > 0) {
            CommonSecurity.promoteStorage();
            this.mso_login = true;
            window.onbeforeunload = () => {
              CommonSecurity.clearAllStorage();
            };
          } else {
            this.mso_login = false;
          }
        }
      }

      this.loading = false;
    },
  },
};
</script>
